import { Component, inject } from '@angular/core';
import { BrandingService } from '@next/core-lib/branding';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private readonly brandingService = inject(BrandingService);

  navigationItems = [
    {
      relativeUrl: '/customer',
      label: 'app.customer.customer',
      icon: 'business',
    },
    {
      relativeUrl: '/contactperson',
      label: 'app.contactperson.contactpersons',
      icon: 'contacts',
    },
    ...(this.brandingService.isTenant('Agravis')
      ? [
          {
            relativeUrl: '/employees',
            label: 'app.employee.employees',
            icon: 'badge',
          },
        ]
      : []),
  ];
}
